<template>
  <div class="image-options-setting-dialog">
    <div v-show="activeType == 1" class="content-group-default">
      <el-collapse v-model="activeNames">
        <template v-if="curSub === 0">
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')"
          title="标签"
          name="2"
        >
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')"
          >
            <div class="subItemBox" @click="changeSubItem(1, true)">
              <span class="subItemTitle">切换项</span>
              <span class="subItemLabel fs12">配置<i class="subItemIcon icon-portal-arrows-right"></i></span>
            </div>
          </div>
        </el-collapse-item>
        <controlWidthAndSizeAndZindex  :options="options" :ids="ids"/>
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '4')" title="排列" name="4">
          <div
            class="setting-item clearFloat"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')"
          >
            <div class="content-item verticallyCenter">
              <slider-and-input
                inputWidth="small"
                :value.sync="marginRight"
                title="左右间距"
                titlePosition="singleLine"
                :sliderMax="500"
                suffix="px"
              />
            </div>
            <div class="content-item mt12 verticallyCenter">
              <slider-and-input
                inputWidth="small"
                :value.sync="marginBottom"
                title="上下间距"
                titlePosition="singleLine"
                :sliderMax="500"
                suffix="px"
              />
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
          title="背景"
          name="6"
        >
          <div class="content-item">
            <cx-background :background.sync="background" imgType="10" />
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '7')"
          title="边框"
          name="7"
        >
          <div class="content-item">
            <div class="content-item verticallyCenter mb12">
              <el-checkbox v-model="showAllBorder">显示边框</el-checkbox>
            </div>
            <cx-border
              v-if="showAllBorder"
              :borderWidth.sync="allBorderWidth"
              :borderStyle.sync="allBorderStyle"
              :borderColor.sync="allBorderColor"
              :borderIsThemeColor.sync="allBorderIsThemeColor"
            />
          </div>
          <div class="content-item mt12">
            <border-radius
              :borderTypeFlag.sync="allBorderTypeFlag"
              :borderRadius.sync="allBorderRadius"
              :borderTopLeftRadius.sync="allBorderTopLeftRadius"
              :borderTopRightRadius.sync="allBorderTopRightRadius"
              :borderBottomRightRadius.sync="allBorderBottomRightRadius"
              :borderBottomLeftRadius.sync="allBorderBottomLeftRadius"
            />
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '8')"
          title="边距"
          name="8"
        >
          <div class="content-item">
            <cx-padding
              :paddingTypeFlag.sync="ulPaddingTypeFlag"
              :padding.sync="ulPadding"
              :paddingTop.sync="ulPaddingTop"
              :paddingRight.sync="ulPaddingRight"
              :paddingBottom.sync="ulPaddingBottom"
              :paddingLeft.sync="ulPaddingLeft"
            />
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')" title="更多" name="5">
          <div class="content" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')">
            <div class="content-item">
              <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
            </div>
            <!-- <div class="content-item mt16 clearFloat">
              <div class="checkbox_colorPicker_container mb16">
                <span class="fs14">边框</span>
              </div>
              <div v-show="borderChecked" class="select-input-container verticallyTop">
                <cx-border
                  :borderWidth.sync="allBorderWidth"
                  :borderStyle.sync="allBorderStyle"
                  :borderColor.sync="allBorderColor"
                  :borderIsThemeColor.sync="allBorderIsThemeColor"
                />
              </div>
            </div> -->
            <!-- <div class="content-item mt16">
              <cx-padding
                :paddingTypeFlag.sync="paddingTypeFlag"
                :padding.sync="padding"
                :paddingTop.sync="paddingTop"
                :paddingRight.sync="paddingRight"
                :paddingBottom.sync="paddingBottom"
                :paddingLeft.sync="paddingLeft"
              />
            </div> -->
            <div class="content-item mt12">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('b')"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="boxShadowH"
                :boxShadowV.sync="boxShadowV"
                :boxShadowBlur.sync="boxShadowBlur"
                :boxShadowSpread.sync="boxShadowSpread"
                :boxShadowColor.sync="boxShadowColor"
              ></box-shadow>
            </div>
            <div class="content-item verticallyCenter mt12">
              <el-checkbox class="" v-model="showTabsScorll">开启横向滚动</el-checkbox>
            </div>
            <div class="content-item mt12">
              <public-style :options="options" :ids="ids"></public-style>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          v-show="$store.state.states.showPluginSetting"
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '9')"
          title="插件"
          name="9"
        >
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '9')"
          >
            <elementPluginSetting :pluginName="pluginName" :myid="ids"></elementPluginSetting>
          </div>
        </el-collapse-item>
        </template>
        <template v-if="curSub === 1">
          <div class="subBackBox" @click="changeSubItem(0, false)">
            <i class="subBackIcon icon-portal-arrows-left"></i>
            <span class="subBackTitle">切换项</span>
          </div>
          <cx-slider
            class="rect-active-slider"
            label="状态"
            :value.sync="statusType"
            :options="statusTypeOptions"
          />
          <!-- 默认状态 -->
          <template v-if="statusType === '1'">
            <tabSize :options="options" :ids="ids"/>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')"
              title="尺寸"
              name="1"
              style="display: none;"
            >
              <div class="content">
                <div class="content-item mb16 verticallyCenter">
                  <div class="verticallyCenter">
                    <span class="fs14 mr16">宽度</span>
                    <el-radio-group v-model="widthAuto">
                      <el-radio :label="true">自适应</el-radio>
                      <el-radio :label="false">固定宽度</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="content-item verticallyCenter">
                  <slider-and-input
                    v-if="!widthAuto"
                    :value.sync="tabWidth"
                    titlePosition="singleLine"
                    :sliderMax="500"
                    suffix="px"
                  />
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
              title="文字"
              name="3"
            >
              <div
                class="setting-item"
                v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')"
              >
                <text-setting-complex-update
                  :fontFamily.sync="fontFamily"
                  :fontSize.sync="fontSize"
                  :fontWeight.sync="fontWeight"
                  :fontStyle.sync="fontStyle"
                  :textDecoration.sync="textDecoration"
                  :lineHeight.sync="lineHeight"
                  :letterSpacing.sync="letterSpacing"
                  :activeArrangement.sync="activeArrangement"
                  :writingMode.sync="writingMode"
                  :textAlign.sync="textAlign"
                  :activeArrangementOrder.sync="activeArrangementOrder"
                  :lineHeightType.sync="lineHeightType"
                  :letterSpacingType.sync="letterSpacingType"
                  :isThemeColor.sync="textIsThemeColor"
                  :colorArr.sync="color"
                  :showOverflowSetting="true"
                  :contentHasLimit.sync="contentHasLimit"
                  :contentHasLimitRadio.sync="contentHasLimitRadio"
                  :textLimitWords.sync="textLimitLines"
                  :textLimitLines.sync="textLimitWords"
                  :options="options"
                />
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
              title="背景"
              name="6"
            >
              <div class="content-item clearFloat">
                <cx-background :background.sync="defaultBackground" imgType="10" class="" />
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '7')"
              title="图标"
              name="7"
            >
              <div
                class="setting-item"
                v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '7')"
              >
                <div class="content">
                  <el-checkbox v-model="showIcon" class="">显示图标</el-checkbox>
                  <img-icon-upload
                    v-show="showIcon && isInLayoutTabs"
                    class="mt16"
                    :imgSrc.sync="iconSrc"
                    :iconType.sync="iconType"
                    :iconColor.sync="iconColor"
                    :resInfo.sync="resInfo"
                  />
                  <div v-show="showIcon" class="content-item mt16 verticallyCenter">
                    <span class="mr16 fs14">位置</span>
                    <el-radio-group v-model="iconPosition">
                      <el-radio label="top">上</el-radio>
                      <el-radio label="bottom">下</el-radio>
                      <el-radio label="left">左</el-radio>
                      <el-radio label="right">右</el-radio>
                    </el-radio-group>
                  </div>
                  <slider-and-input
                    v-show="showIcon"
                    class="mt16"
                    :value.sync="iconMargin"
                    title="间距"
                    :sliderMax="iptSliderMax"
                    suffix="px"
                  />
                  <div v-show="showIcon" class="verticallyCenter mt16 content-item">
                    <span class="mr16 fs14">颜色</span>
                    <cx-color-picker class="flex1" :isThemeColor.sync="iconColorIsThemeColor" :colorArr.sync="iconColor">
                    </cx-color-picker>
                  </div>
                  <slider-and-input
                    v-show="showIcon"
                    class="mt16"
                    :value.sync="iconWidth"
                    title="宽度"
                    :sliderMax="iptSliderMax"
                    suffix="px"
                  />
                  <slider-and-input
                    v-show="showIcon"
                    class="mt16"
                    :value.sync="iconHeight"
                    title="高度"
                    :sliderMax="iptSliderMax"
                    suffix="px"
                  />
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="分隔符" name="11">
              <el-checkbox v-model="showDivide">显示分隔符</el-checkbox>
              <div class="content-item mt12" v-if="showDivide">
                <cx-slider label="类型" :value.sync="divideType" :options="divideTypeOptions" />
                <div class="mt12" v-if="divideType === 'custom'">
                  <img-icon-upload
                    :imgSrc.sync="divideIconSrc"
                    :iconType.sync="divideIconType"
                    :iconColor.sync="divideIconColor"
                    :resInfo.sync="divideResInfo"
                  />
                  <div class="verticallyCenter mt12" v-if="divideIconType !== 'img'">
                    <span class="mr16 fs14">颜色</span>
                    <cx-color-picker class="flex1" :isThemeColor.sync="divideIconColorIsThemeColor" :colorArr.sync="divideIconColor">
                    </cx-color-picker>
                  </div>
                </div>
                <div class="mt12" v-else>
                  <div class="verticallyCenter">
                    <span class="mr16 fs14">颜色</span>
                    <cx-color-picker class="flex1" :isThemeColor.sync="iconColorIsThemeColor" :colorArr.sync="divideIconColor">
                    </cx-color-picker>
                  </div>
                </div>
                <div class="verticallyCenter mt12">
                  <span class="mr16 fs14">尺寸</span>
                  <div class="verticallyCenter mr16 flex1">
                    <single-input
                      class="input-size"
                      placeholder="-"
                      :value.sync="divideWidth"
                      :min="1"
                      inputSuffixs="宽"
                     />
                    </div>
                  <div class="verticallyCenter flex1">
                    <single-input
                      class="input-size"
                      placeholder="-"
                      :value.sync="divideHeight"
                      :min="1"
                      inputSuffixs="高"
                    />
                  </div>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '8')"
              title="边框"
              name="8"
            >
              <div class="content-item">
                <div class="content-item verticallyCenter mb12">
                  <el-checkbox v-model="showBorder">显示边框</el-checkbox>
                </div>
                <cx-border
                  v-if="showBorder"
                  :borderWidth.sync="borderWidth"
                  :borderStyle.sync="borderStyle"
                  :borderColor.sync="borderColor"
                  :borderIsThemeColor.sync="borderIsThemeColor"
                />
              </div>
              <div class="content-item mt12">
                <border-radius
                  :borderTypeFlag.sync="borderTypeFlag"
                  :borderRadius.sync="borderRadius"
                  :borderTopLeftRadius.sync="borderTopLeftRadius"
                  :borderTopRightRadius.sync="borderTopRightRadius"
                  :borderBottomRightRadius.sync="borderBottomRightRadius"
                  :borderBottomLeftRadius.sync="borderBottomLeftRadius"
                />
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')"
              title="边距"
              name="5"
            >
              <div class="content-item clearFloat">
                <cx-padding
                  :paddingTypeFlag.sync="paddingTypeFlag"
                  :padding.sync="padding"
                  :paddingTop.sync="paddingTop"
                  :paddingRight.sync="paddingRight"
                  :paddingBottom.sync="paddingBottom"
                  :paddingLeft.sync="paddingLeft"
                />
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '10')"
              title="更多"
              name="10"
            >
              <div class="content-item">
                <slider-and-input :value.sync="tabOpacity" title="透明度" :sliderMax="100" suffix="%" />
              </div>
              <div class="content-item mt12">
                <div class="checkbox_colorPicker_container">
                  <span>阴影</span>
                  <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('defaultB')"></span>
                </div>
                <box-shadow
                  :boxShadowH.sync="defaultBoxShadowH"
                  :boxShadowV.sync="defaultBoxShadowV"
                  :boxShadowBlur.sync="defaultBoxShadowBlur"
                  :boxShadowSpread.sync="defaultBoxShadowSpread"
                  :boxShadowColor.sync="defaultBoxShadowColor"
                ></box-shadow>
              </div>
            </el-collapse-item>
          </template>
          <!-- 选中状态 -->
          <template v-if="statusType === '2'">
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')"
              title="文字样式"
              name="2"
            >
              <div
                class="setting-item"
                v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')"
              >
                <div class="content">
                  <text-setting-complex-update
                    :fontFamily.sync="hoverFontFamily"
                    :fontSize.sync="hoverFontSize"
                    :fontWeight.sync="hoverFontWeight"
                    :fontStyle.sync="hoverFontStyle"
                    :textDecoration.sync="hoverTextDecoration"
                    :lineHeight.sync="hoverLineHeight"
                    :letterSpacing.sync="hoverLetterSpacing"
                    :activeArrangement.sync="hoverActiveArrangement"
                    :writingMode.sync="hoverWritingMode"
                    :textAlign.sync="activeTextAlign"
                    :activeArrangementOrder.sync="hoverActiveArrangementOrder"
                    :lineHeightType.sync="hoverLineHeightType"
                    :letterSpacingType.sync="hoverLetterSpacingType"
                    :isThemeColor.sync="hoverTextIsThemeColor"
                    :colorArr.sync="hoverColor"
                  />
                  <div class="content-item mt16">
                    <div class="">
                      <el-checkbox v-model="hoverBorderChecked">下划线</el-checkbox>
                      <line-setting
                        v-if="hoverBorderChecked"
                        class="mt16"
                        title=""
                        :lineName.sync="hoverUnderlineStyle"
                        :lineWidth.sync="hoverUnderlineWidth"
                        :lineColor.sync="hoverUnderlineColor"
                        suffix="px"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
              title="背景"
              name="6"
            >
              <div class="content-item clearFloat">
                <cx-background :background.sync="hoverBackground" imgType="10" class="" />
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
              title="边框"
              name="3"
            >
              <div class="content-item">
                <div class="content-item verticallyCenter mb12">
                  <el-checkbox v-model="showHoverBorder">显示边框</el-checkbox>
                </div>
                <cx-border
                  v-if="showHoverBorder"
                  :borderWidth.sync="hoverBorderWidth"
                  :borderStyle.sync="hoverBorderStyle"
                  :borderColor.sync="hoverBorderColor"
                  :borderIsThemeColor.sync="hoverBorderIsThemeColor"
                />
              </div>
              <div class="content-item mt12">
                <border-radius
                  :borderTypeFlag.sync="hoverBorderTypeFlag"
                  :borderRadius.sync="hoverBorderRadius"
                  :borderTopLeftRadius.sync="hoverBorderTopLeftRadius"
                  :borderTopRightRadius.sync="hoverBorderTopRightRadius"
                  :borderBottomRightRadius.sync="hoverBorderBottomRightRadius"
                  :borderBottomLeftRadius.sync="hoverBorderBottomLeftRadius"
                />
              </div>
            </el-collapse-item>
            <el-collapse-item
                @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')"
                title="边距"
                name="5"
            >
              <div class="content-item clearFloat">
                <cx-padding
                    :paddingTypeFlag.sync="hoverPaddingTypeFlag"
                    :padding.sync="hoverPadding"
                    :paddingTop.sync="hoverPaddingTop"
                    :paddingRight.sync="hoverPaddingRight"
                    :paddingBottom.sync="hoverPaddingBottom"
                    :paddingLeft.sync="hoverPaddingLeft"
                />
              </div>
            </el-collapse-item>
          </template>
          <!-- 悬浮状态 -->
          <template v-if="statusType === '3'">
            <el-checkbox class="paddingl15 mb12 mt8" v-if="!hasDataSource" v-model="hoverIsSameActive">同选中状态</el-checkbox>
            <div v-if="!hoverIsSameActive">
              <el-collapse-item
                @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')"
                title="文字样式"
                name="2"
              >
                <div
                  class="setting-item"
                  v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')"
                >
                  <div class="content">
                    <text-setting-complex-update
                      :fontFamily.sync="activeFontFamily"
                      :fontSize.sync="activeFontSize"
                      :fontWeight.sync="activeFontWeight"
                      :fontStyle.sync="activeFontStyle"
                      :textDecoration.sync="activeTextDecoration"
                      :lineHeight.sync="activeLineHeight"
                      :letterSpacing.sync="activeLetterSpacing"
                      :activeArrangement.sync="activeActiveArrangement"
                      :writingMode.sync="activeWritingMode"
                      :textAlign.sync="hoverTextAlign"
                      :activeArrangementOrder.sync="activeActiveArrangementOrder"
                      :lineHeightType.sync="activeLineHeightType"
                      :letterSpacingType.sync="activeLetterSpacingType"
                      :isThemeColor.sync="activeTextIsThemeColor"
                      :colorArr.sync="activeColor"
                      :options="options"
                    />
                    <div class="content-item mt16">
                      <div class="">
                        <el-checkbox v-model="activeBorderChecked">下划线</el-checkbox>
                        <line-setting
                          v-if="activeBorderChecked"
                          class="mt16"
                          title=""
                          :lineName.sync="activeUnderlineStyle"
                          :lineWidth.sync="activeUnderlineWidth"
                          :lineColor.sync="activeUnderlineColor"
                          suffix="px"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item
                @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
                title="背景"
                name="6"
              >
                <div class="content-item clearFloat">
                  <cx-background :background.sync="activeBackground" imgType="10" class="" />
                </div>
              </el-collapse-item>
              <el-collapse-item
                @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
                title="边框"
                name="3"
              >
                <div class="content-item">
                  <div class="content-item verticallyCenter mb12">
                    <el-checkbox v-model="showActiveBorder">显示边框</el-checkbox>
                  </div>
                  <cx-border
                    v-if="showActiveBorder"
                    :borderWidth.sync="activeBorderWidth"
                    :borderStyle.sync="activeBorderStyle"
                    :borderColor.sync="activeBorderColor"
                    :borderIsThemeColor.sync="activeBorderIsThemeColor"
                  />
                </div>
                <div class="content-item mt12">
                  <border-radius
                    :borderTypeFlag.sync="activeBorderTypeFlag"
                    :borderRadius.sync="activeBorderRadius"
                    :borderTopLeftRadius.sync="activeBorderTopLeftRadius"
                    :borderTopRightRadius.sync="activeBorderTopRightRadius"
                    :borderBottomRightRadius.sync="activeBorderBottomRightRadius"
                    :borderBottomLeftRadius.sync="activeBorderBottomLeftRadius"
                  />
                </div>
              </el-collapse-item>
              <el-collapse-item
                  @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')"
                  title="边距"
                  name="5"
              >
                <div class="content-item clearFloat">
                  <cx-padding
                      :paddingTypeFlag.sync="activePaddingTypeFlag"
                      :padding.sync="activePadding"
                      :paddingTop.sync="activePaddingTop"
                      :paddingRight.sync="activePaddingRight"
                      :paddingBottom.sync="activePaddingBottom"
                      :paddingLeft.sync="activePaddingLeft"
                  />
                </div>
              </el-collapse-item>
            </div>
          </template>
        </template>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import TextSettingComplex from "modules/components/textSettingComplex"
import elementPluginSetting from "publicSetting/elementPluginSetting"
import { deepChangeAnimateUid } from "utils/event/animate"
import { withMethodsHistoryCombine } from "utils/revork"
import rowColLayoutSize from "publicSetting/rowColLayoutSize"
import tabSize from "./setting/tabSize"
import publicStyle from "publicSetting/publicStyle.vue"
import { CATEGORY_MODE } from "@/consts"
export default withMethodsHistoryCombine({
  name: "image-options-data",
  components: { controlWidthAndSizeAndZindex, TextSettingComplex, elementPluginSetting, rowColLayoutSize, tabSize, publicStyle },
  props: { options: Object, activeType: String },
  data() {
    return {
      this1: this,
      collapseActiveNames: ["1", "2", "9"],
      activeNames: ["1", "2", "9"],
      allCollapseNames: ["3", "4", "6"],
      iconLocations: [
        {
          value: "left",
          title: "文字居左"
        },
        {
          value: "right",
          title: "文字居右"
        }
      ],
      sliderMin: 1,
      sliderMax: 5,
      isShowBackgroundList: [
        {
          label: 0,
          title: "无背景"
        },
        {
          label: 1,
          title: "有背景"
        }
      ],
      borderChecked: true,
      allTabs: [],
      getAllTabsIsCheckedAll: false,
      allTabsIsCheckedAll: false,
      iptSliderMax: 360,
      curSub: 0,
      statusType: "1",
      statusTypeOptions: [
        { value: "1", title: "默认" },
        { value: "2", title: "选中" },
        { value: "3", title: "悬浮" }
      ],
      divideTypeOptions: [
        {
          value: "line",
          title: "竖线",
        },
        {
          value: "custom",
          title: "自定义",
        },
      ],
    }
  },
  watch:{
    "$store.state.states.activeID": {
      handler(){
        this.changeSubItem(0, false)
        this.$nextTick(()=>{
          if(this.hasDataSource) {
            this.hoverIsSameActive = false
          }
        })
      },
      deep:true
    },
    "hasDataSource"(newVal){
      if (newVal) {
        this.statusTypeOptions =  [
          { value: "1", title: "默认" },
          { value: "3", title: "悬浮" }
        ]
      }else{
        this.statusTypeOptions =  [
          { value: "1", title: "默认" },
          { value: "2", title: "选中" },
          { value: "3", title: "悬浮" }
        ]
      }
    }
  },
  created() {
    console.log(this.options, this)
  },
  mounted() {
    this.$collapseControl({
      allCollapseNames: this.allCollapseNames,
      collapseActiveNames: this.collapseActiveNames,
      activeNames: this.activeNames
    })
    if (this.hasDataSource) {
      this.statusTypeOptions =  [
        { value: "1", title: "默认" },
        { value: "3", title: "悬浮" }
      ]
      this.hoverIsSameActive = false
    }
  },
  computed: {
    hasDataSource() {
      return this.options.hasDataSource
    },
    ids() {
      return this.$store.state.states.activeID
    },
    rectOptions() {
      const stage = this.$store.state[this.request_prefix]
      let rectAttr = this.getAttrById(stage, this.ids, "rect")?.options
      return rectAttr
    },
    activeRect() {
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    isShowSyncSet() {
      return this.options.isNoSyncData ? false : true
    },
    activeArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.writingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "writingMode", false)
      }
    },
    hoverActiveArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.hoverWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "hoverWritingMode", false)
      }
    },
    activeArrangement() {
      return this.options.textAlign
    },
    hoverActiveArrangement() {
      return this.options.activeTextAlign
    },
    hoverBackground: {
      get() {
        let background = this.options.hoverBackground
        if (background && Array.isArray(background) && background.length > 0) {
          if (typeof background[0].color === "object") {
            background[0].color = background[0].color?.color
          }
          return background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hoverBgColorIsThemeColor,
            color: this.options.hoverBgColor.color ? this.options.hoverBgColor.color : this.options.hoverBgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "hoverBackground", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        if (typeof newVal[0].color === "object") {
          newVal[0].color = newVal[0].color?.color
        }
        this.$changeOptionsEV(newVal, "hoverBackground", false)
      }
    },
    defaultBackground: {
      get() {
        let background = this.options.defaultBackground
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.defaultBackground
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.bgColorIsThemeColor,
            color: this.options.bgColor.color ? this.options.bgColor.color : this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "defaultBackground", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBackground", false)
      }
    },
    activeBackground: {
      get() {
        let background = this.options.activeBackground
        if (background && Array.isArray(background) && background.length > 0) {
          if (typeof background[0].color === "object") {
            background[0].color = background[0].color?.color
          }
          return background
        }
        let newBackground = this.options.activeBgColor ? [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.activeBgColorIsThemeColor,
            color: this.options.activeBgColor.color ? this.options.activeBgColor.color : this.options.activeBgColor
          }
        ] : this.hoverBackground
        this.$changeOptionsEV(newBackground, "activeBackground", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        if (typeof newVal[0].color === "object") {
          newVal[0].color = newVal[0].color?.color
        }
        this.$changeOptionsEV(newVal, "activeBackground", false)
      }
    },
    width: {
      get() {
        return this.options.width
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "width", false)
      }
    },
    height: {
      get() {
        return this.options.height
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "height", false)
      }
    },
    pluginName: {
      get() {
        if (!this.hasProperty(this.options, "pluginName")) {
          this.options.pluginName = []
          this.$changeOptionsEV([], "pluginName", false, false, false, true)
        }
        return this.options.pluginName
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pluginName", false)
      }
    },
    iconLocation: {
      get() {
        return this.options.iconLocation || "left"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconLocation", false)
      }
    },
    showIconChecked: {
      get() {
        return this.options.showIconChecked
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showIconChecked", false)
      }
    },
    hoverBorderChecked: {
      get() {
        return this.options.hoverBorderChecked || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderChecked", false)
      }
    },
    left: {
      get() {
        return this.options.left
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "left", false)
      }
    },
    top: {
      get() {
        return this.options.top
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "top", false)
      }
    },
    hoverBorderColor: {
      get() {
        return this.options.hoverBorderColor || this.options.borderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderColor", false)
      }
    },
    fontFamily: {
      get() {
        return this.options.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontFamily", false)
      }
    },
    hoverFontFamily: {
      get() {
        return this.options.hoverFontFamily || this.options.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontFamily", false)
      }
    },
    fontSize: {
      get() {
        return this.options.fontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontSize", false)
      }
    },
    hoverFontSize: {
      get() {
        return this.options.hoverFontSize || parseInt(this.options.fontSize)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontSize", false)
      }
    },
    fontWeight: {
      get() {
        return this.options.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontWeight", false)
      }
    },
    hoverFontWeight: {
      get() {
        return this.options.hoverFontWeight || this.options.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontWeight", false)
      }
    },
    color: {
      get() {
        return this.options.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "color", false)
      }
    },
    textIsThemeColor: {
      get() {
        return this.options.textIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textIsThemeColor", false)
      }
    },
    hoverColor: {
      get() {
        return this.options.hoverColor || this.options.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverColor", false)
      }
    },
    hoverTextIsThemeColor: {
      get() {
        return this.options.hoverTextIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverTextIsThemeColor", false)
      }
    },
    textAlign: {
      get() {
        return this.options.textAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textAlign", false)
      }
    },
    hoverTextAlign: {
      get() {
        return this.options.hoverTextAlign || this.options.textAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverTextAlign", false)
      }
    },
    fontStyle: {
      get() {
        return this.options.fontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontStyle", false)
      }
    },
    hoverFontStyle: {
      get() {
        return this.options.hoverFontStyle || this.options.fontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontStyle", false)
      }
    },
    lineHeight: {
      get() {
        return this.options.lineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeight", false)
      }
    },
    hoverLineHeight: {
      get() {
        return this.options.hasOwnProperty("hoverLineHeight") ? this.options.hoverLineHeight : this.options.lineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverLineHeight", false)
      }
    },
    letterSpacing: {
      get() {
        return this.options.letterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "letterSpacing", false)
      }
    },
    hoverLetterSpacing: {
      get() {
        return this.options.hasOwnProperty("hoverLetterSpacing")
          ? this.options.hoverLetterSpacing
          : this.options.letterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "hoverLetterSpacing", false)
      }
    },
    writingMode: {
      get() {
        return this.options.writingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "writingMode", false)
      }
    },
    hoverWritingMode: {
      get() {
        return this.options.hasOwnProperty("hoverWritingMode")
          ? this.options.hoverWritingMode
          : this.options.writingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverWritingMode", false)
      }
    },
    textDecoration: {
      get() {
        return this.options.textDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textDecoration", false)
      }
    },
    hoverTextDecoration: {
      get() {
        return this.options.hoverTextDecoration || this.options.textDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverTextDecoration", false)
      }
    },
    textIndent: {
      get() {
        return this.options.textIndent
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textIndent", false)
      }
    },
    hoverTextIndent: {
      get() {
        return this.options.hoverTextIndent || this.options.textIndent
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverTextIndent", false)
      }
    },
    maxLength: {
      get() {
        return this.options.maxLength || 2
      },
      set(newVal) {
        newVal = newVal > 5 ? 5 : newVal
        this.$changeOptionsEV(newVal, "maxLength", false)
      }
    },
    maxTabLength: {
      get() {
        return this.options.hasOwnProperty("maxTabLength") ? this.options.maxTabLength : 5
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "maxTabLength", false)
      }
    },
    hoverMaxTabLength: {
      get() {
        return this.options.hasOwnProperty("hoverMaxTabLength")
          ? this.options.hoverMaxTabLength
          : this.options.maxTabLength
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverMaxTabLength", false)
      }
    },
    widthAuto: {
      get() {
        return this.options.widthAuto || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "widthAuto", false)
      }
    },
    tabWidth: {
      get() {
        return this.options.tabWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tabWidth", false)
      }
    },
    tabHeight: {
      get() {
        return this.options.tabHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tabHeight", false)
      }
    },
    bgColor: {
      get() {
        return this.options.bgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColor", false)
      }
    },
    hoverBgColor: {
      get() {
        return this.options.hoverBgColor || this.options.bgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBgColor", false)
      }
    },
    marginRight: {
      get() {
        return this.options.marginRight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "marginRight", false)
      }
    },
    marginBottom: {
      get() {
        return this.options.marginBottom
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "marginBottom", false)
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.options.borderTopLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return this.options.borderTopRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.options.borderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.options.borderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    borderRadius: {
      get() {
        return this.options.borderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
          false
        )
      }
    },
    borderStyle: {
      get() {
        return this.options.borderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    borderColor: {
      get() {
        return this.options.borderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (
            ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
            this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        // return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.options.borderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    showBorder: {
      get() {
        let showBorder = false
        if (this.options.showBorder === undefined) {
          if (Array.isArray(this.options.borderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.borderWidth.length; i++) {
              if (this.options.borderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              showBorder = false
            } else {
              showBorder = true
            }
          } else {
            if (this.options.borderWidth) {
              showBorder = true
            } else {
              showBorder = false
            }
          }
          this.$changeOptionsEV(showBorder, "showBorder", false)
        } else {
          showBorder = this.options.showBorder
        }
        return showBorder
      },
      set(newVal) {
        if(newVal && !this.borderWidth) {
          this.$changeOptionsEV([1, newVal], ["borderWidth", "showBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showBorder", false)
        }
      }
    },
    borderWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderWidth", "borderWidth", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.options.borderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    },
    hoverBorderIsThemeColor: {
      get() {
        return this.options.hoverBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderIsThemeColor", false)
      }
    },
    isShowBackgroundModel: {
      get() {
        return this.options.isShowBackgroundModel || "无背景"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "isShowBackgroundModel", false)
      }
    },
    bgColorIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColorIsThemeColor", false)
      }
    },
    hoverBgColorIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("hoverBgColorIsThemeColor") ? this.options.hoverBgColorIsThemeColor : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBgColorIsThemeColor", false)
      }
    },
    showHoverBorder: {
      get() {
        let showBorder = false
        if (this.options.showHoverBorder === undefined) {
          if (Array.isArray(this.options.hoverBorderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.hoverBorderWidth.length; i++) {
              if (this.options.hoverBorderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              showBorder = false
            } else {
              showBorder = true
            }
          } else {
            if (this.options.hoverBorderWidth) {
              showBorder = true
            } else {
              showBorder = false
            }
          }
          this.$changeOptionsEV(showBorder, "showHoverBorder", false)
        } else {
          showBorder = this.options.showHoverBorder
        }
        return showBorder
      },
      set(newVal) {
        if(newVal && !this.hoverBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["hoverBorderWidth", "showHoverBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showHoverBorder", false)
        }
      }
    },
    hoverBorderWidth: {
      get() {
        return this.options.hasOwnProperty("hoverBorderWidth")
          ? this.options.hoverBorderWidth
          : this.options.borderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderWidth", false)
      }
    },
    hoverBorderStyle: {
      get() {
        return this.options.hasOwnProperty("hoverBorderStyle")
          ? this.options.hoverBorderStyle
          : this.options.borderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderStyle", false)
      }
    },
    hoverUnderlineColor: {
      get() {
        return this.options.hoverUnderlineColor || "#fff"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverUnderlineColor", false)
      }
    },
    hoverUnderlineStyle: {
      get() {
        return this.options.hoverUnderlineStyle || "#fff"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverUnderlineStyle", false)
      }
    },
    hoverUnderlineWidth: {
      get() {
        return this.options.hoverUnderlineWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverUnderlineWidth", false)
      }
    },
    singleTabs() {
      return this.options.singleTabs ? this.options.singleTabs : false
    },
    opacity: {
      get() {
        return this.options.hasOwnProperty("opacity") ? this.options.opacity : 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    tabOpacity: {
      get() {
        return this.options.hasOwnProperty("tabOpacity") ? this.options.tabOpacity : 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tabOpacity", false)
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.background
        }
        let newBackground = []
        if (this.bgType === "线性渐变") {
          newBackground.push({
            type: "linearGradient",
            label: "线性渐变",
            data: {
              angle: this.bgColorlinearGradientAngle,
              stops: [
                [this.bgStartColor, 0],
                [this.bgEndColor, 1]
              ]
            }
          })
        }
        if (this.bgType === "径向渐变") {
          newBackground.push({
            type: "radialGradient",
            label: "径向渐变",
            data: {
              siteX: 50,
              siteY: 50,
              stops: [
                [this.bgStartColor, 0],
                [this.bgEndColor, 1]
              ]
            }
          })
        }
        newBackground.push({
          type: "color",
          label: "颜色",
          isThemeColor: false,
          color: this.bgType === "纯色" ? this.allBgColor : "rgba(0,0,0,0)"
        })
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "background", false)
      }
    },
    bgType: {
      get() {
        return this.options.bgType || "纯色"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgType", false)
      }
    },
    allBgColor: {
      get() {
        return this.options.allBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBgColor", false)
      }
    },
    bgStartColor: {
      get() {
        return this.options.bgStartColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgStartColor", false)
      }
    },
    bgEndColor: {
      get() {
        return this.options.bgEndColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgEndColor", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.options.hasOwnProperty("boxShadowColor") ? this.options.boxShadowColor : ["rgba(255,255,255,1)"]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.options.hasOwnProperty("boxShadowH") ? this.options.boxShadowH : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.options.hasOwnProperty("boxShadowV") ? this.options.boxShadowV : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.hasOwnProperty("boxShadowBlur") ? this.options.boxShadowBlur : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.hasOwnProperty("boxShadowSpread") ? this.options.boxShadowSpread : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    defaultBoxShadowColor: {
      get() {
        return this.options.hasOwnProperty("defaultBoxShadowColor") ? this.options.defaultBoxShadowColor : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBoxShadowColor", false)
      }
    },
    defaultBoxShadowH: {
      get() {
        return this.options.hasOwnProperty("defaultBoxShadowH") ? this.options.defaultBoxShadowH : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBoxShadowH", false)
      }
    },
    defaultBoxShadowV: {
      get() {
        return this.options.hasOwnProperty("defaultBoxShadowV") ? this.options.defaultBoxShadowV : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBoxShadowV", false)
      }
    },
    defaultBoxShadowBlur: {
      get() {
        return this.options.hasOwnProperty("defaultBoxShadowBlur") ? this.options.defaultBoxShadowBlur : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBoxShadowBlur", false)
      }
    },
    defaultBoxShadowSpread: {
      get() {
        return this.options.hasOwnProperty("defaultBoxShadowSpread") ? this.options.defaultBoxShadowSpread : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBoxShadowSpread", false)
      }
    },
    allBorderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("allBorderTypeFlag")) {
          if (
            ((this.allBorderTopLeftRadius === this.allBorderTopRightRadius) === this.allBorderBottomLeftRadius) ===
            this.allBorderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        return this.options.allBorderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderTypeFlag", false)
      }
    },
    allBorderRadius: {
      get() {
        // return this.options.borderRadius || 0
        return this.checkAndSetPrimaryVal(
          this.options,
          "allBorderRadius",
          "allBorderRadius",
          this.allBorderTopLeftRadius
        )
      },
      set(newVal) {
        if (this.allBorderTypeFlag === 2) {
          this.allBorderTopLeftRadius = newVal
          this.allBorderTopRightRadius = newVal
          this.allBorderBottomLeftRadius = newVal
          this.allBorderBottomRightRadius = newVal
        }
        this.$changeOptionsEV(newVal, "borderRadius", false)
      }
    },
    allBorderTopLeftRadius: {
      get() {
        // return this.options.allBorderTopLeftRadius || 0
        return this.checkAndSetPrimaryVal(this.options, "allBorderTopLeftRadius", "allBorderTopLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderTopLeftRadius", false)
      }
    },
    allBorderTopRightRadius: {
      get() {
        // return this.options.allBorderTopRightRadius || 0
        return this.checkAndSetPrimaryVal(this.options, "allBorderTopRightRadius", "allBorderTopRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderTopRightRadius", false)
      }
    },
    allBorderBottomLeftRadius: {
      get() {
        // return this.options.allBorderBottomLeftRadius || 0
        return this.checkAndSetPrimaryVal(this.options, "allBorderBottomLeftRadius", "allBorderBottomLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderBottomLeftRadius", false)
      }
    },
    allBorderBottomRightRadius: {
      get() {
        // return this.options.allBorderBottomRightRadius || 0
        return this.checkAndSetPrimaryVal(this.options, "allBorderBottomRightRadius", "allBorderBottomRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderBottomRightRadius", false)
      }
    },
    allBorderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "allBorderIsThemeColor", "allBorderIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderIsThemeColor", false)
      }
    },
    showAllBorder: {
      get() {
        let showBorder = false
        if (this.options.showAllBorder === undefined) {
          if (Array.isArray(this.options.allBorderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.allBorderWidth.length; i++) {
              if (this.options.allBorderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              showBorder = false
            } else {
              showBorder = true
            }
          } else {
            if (this.options.allBorderWidth) {
              showBorder = true
            } else {
              showBorder = false
            }
          }
          this.$changeOptionsEV(showBorder, "showAllBorder", false, false, false, true)
        } else {
          showBorder = this.options.showAllBorder
        }
        return showBorder
      },
      set(newVal) {
        if(newVal && !this.allBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["allBorderWidth", "showAllBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showAllBorder", false)
        }
      }
    },
    allBorderWidth: {
      get() {
        return this.options.hasOwnProperty("allBorderWidth") ? this.options.allBorderWidth : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderWidth", false)
      }
    },
    allBorderStyle: {
      get() {
        return this.options.hasOwnProperty("allBorderStyle") ? this.options.allBorderStyle : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderStyle", false)
      }
    },
    allBorderColor: {
      get() {
        return this.options.hasOwnProperty("allBorderColor") ? this.options.allBorderColor : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderColor", false)
      }
    },
    contentHasLimit: {
      get() {
        return this.options.contentHasLimit
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "contentHasLimit", false)
      }
    },
    contentHasLimitRadio: {
      get() {
        return this.options.hasOwnProperty("contentHasLimitRadio") ? this.options.contentHasLimitRadio : "字数"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "contentHasLimitRadio", false)
      }
    },
    textLimitLines: {
      get() {
        return this.options.textLimitLines
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textLimitLines", false)
      }
    },
    textLimitWords: {
      get() {
        return this.options.textLimitWords || 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textLimitWords", false)
      }
    },
    // 整体边距
    ulPaddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("ulPaddingTypeFlag")) {
          if (((this.paddingTop === this.paddingRight) === this.paddingLeft) === this.paddingBottom) {
            defaultType = 2
          }
        }
        return this.options.ulPaddingTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulPaddingTypeFlag", false)
      }
    },
    ulPadding: {
      get() {
        return this.options.ulPadding || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulPadding", false)
      }
    },
    ulPaddingTop: {
      get() {
        return this.options.ulPaddingTop || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulPaddingTop", false)
      }
    },
    ulPaddingRight: {
      get() {
        return this.options.ulPaddingRight || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulPaddingRight", false)
      }
    },
    ulPaddingLeft: {
      get() {
        return this.options.ulPaddingLeft || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulPaddingLeft", false)
      }
    },
    ulPaddingBottom: {
      get() {
        return this.options.ulPaddingBottom || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulPaddingBottom", false)
      }
    },
    // 边距
    paddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("paddingTypeFlag")) {
          if (((this.paddingTop === this.paddingRight) === this.paddingLeft) === this.paddingBottom) {
            defaultType = 2
          }
        }
        return this.options.paddingTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        return this.options.padding || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.options.paddingTop || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return this.options.paddingRight || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return this.options.paddingLeft || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return this.options.paddingBottom || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },
    lineHeightType: {
      get() {
        return this.options.lineHeightType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeightType", false)
      }
    },
    letterSpacingType: {
      get() {
        return this.options.letterSpacingType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "letterSpacingType", false)
      }
    },
    hoverLineHeightType: {
      get() {
        return this.options.hoverLineHeightType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverLineHeightType", false)
      }
    },
    hoverLetterSpacingType: {
      get() {
        return this.options.hoverLetterSpacingType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverLetterSpacingType", false)
      }
    },
    showIcon: {
      get() {
        return this.options.hasOwnProperty("showIcon") ? this.options.showIcon : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showIcon", false)
      }
    },
    iconSrc: {
      get() {
        return this.options.hasOwnProperty("iconSrc") ? this.options.iconSrc : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconSrc", false)
      }
    },
    iconWidth: {
      get() {
        return this.options.hasOwnProperty("iconWidth") ? this.options.iconWidth : 14
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconWidth", false)
      }
    },
    iconHeight: {
      get() {
        return this.options.hasOwnProperty("iconHeight") ? this.options.iconHeight : 14
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconHeight", false)
      }
    },
    iconMargin: {
      get() {
        return this.options.hasOwnProperty("iconMargin") ? this.options.iconMargin : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconMargin", false)
      }
    },
    iconColor: {
      get() {
        return this.options.hasOwnProperty("iconColor") ? this.options.iconColor : "#000"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColor", false)
      }
    },
    iconColorIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("iconColorIsThemeColor") ? this.options.iconColorIsThemeColor : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColorIsThemeColor", false)
      }
    },
    resInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "resInfo", "resInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "resInfo", false)
      }
    },
    iconPosition: {
      get() {
        return this.options.hasOwnProperty("iconPosition") ? this.options.iconPosition : "left"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconPosition", false)
      }
    },
    iconType: {
      get() {
        return this.options.hasOwnProperty("iconType") ? this.options.iconType : "img"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconType", false)
      }
    },
    showTabsScorll: {
      get() {
        return this.options.hasOwnProperty("showTabsScorll") ? this.options.showTabsScorll : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showTabsScorll", false)
      }
    },
    // 判断当前组件是否是嵌套在自由布局中使用
    isInLayoutTabs() {
      let isInLayoutTabs = false
      // container_id_0-rect_id_71-directionIndex_0-elementInLayoutId_3
      if (this.ids.hasOwnProperty("directionIndex") && this.ids.hasOwnProperty("elementInLayoutId")) {
        isInLayoutTabs = true
      }
      return isInLayoutTabs
    },
    hoverBorderTopLeftRadius: {
      get() {
        return this.options.hasOwnProperty("hoverBorderTopLeftRadius") ? this.options.hoverBorderTopLeftRadius : this.borderTopLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderTopLeftRadius", false)
      }
    },
    hoverBorderTopRightRadius: {
      get() {
        return this.options.hasOwnProperty("hoverBorderTopRightRadius") ? this.options.hoverBorderTopRightRadius : this.borderTopRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderTopRightRadius", false)
      }
    },
    hoverBorderBottomRightRadius: {
      get() {
        return this.options.hasOwnProperty("hoverBorderBottomRightRadius") ? this.options.hoverBorderBottomRightRadius : this.borderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderBottomRightRadius", false)
      }
    },
    hoverBorderBottomLeftRadius: {
      get() {
        return this.options.hasOwnProperty("hoverBorderBottomLeftRadius") ? this.options.hoverBorderBottomLeftRadius : this.borderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderBottomLeftRadius", false)
      }
    },
    hoverBorderRadius: {
      get() {
        return this.options.hasOwnProperty("hoverBorderRadius") ? this.options.hoverBorderRadius : this.borderRadius
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          ["hoverBorderTopLeftRadius", "hoverBorderTopRightRadius", "hoverBorderBottomRightRadius", "hoverBorderBottomLeftRadius"],
          false
        )
        this.$changeOptionsEV(newVal, "hoverBorderRadius", false)
      }
    },
    hoverBorderTypeFlag: {
      get() {
        let defaultType = this.borderTypeFlag
        if (!this.options.hasOwnProperty("hoverBorderTypeFlag")) {
          if (
            ((this.hoverBorderTopLeftRadius === this.hoverBorderTopRightRadius) === this.hoverBorderBottomLeftRadius) ===
            this.hoverBorderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.options.hoverBorderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderTypeFlag", false)
      }
    },
    hoverIsSameActive: {
      get() {
        let hoverIsSameActive = this.options.hasOwnProperty("hoverIsSameActive") ? this.options.hoverIsSameActive : true
        return hoverIsSameActive
      },
      set(newVal) {
        if(!newVal){
          // 取消同步选中状态时，需要将当前的激活属性的值同步给悬浮属性
          // this.activeValueToHover()
        }
        this.$changeOptionsEV(newVal, "hoverIsSameActive", false)
      }
    },
    /* 悬浮样式start */
    activeFontFamily: {
      get() {
        return this.options.activeFontFamily || this.options.hoverFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontFamily", false)
      }
    },
    activeFontSize: {
      get() {
        return this.options.activeFontSize || parseInt(this.options.hoverFontSize)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontSize", false)
      }
    },
    activeFontWeight: {
      get() {
        return this.options.activeFontWeight || this.options.hoverFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontWeight", false)
      }
    },
    activeColor: {
      get() {
        return this.options.activeColor || this.options.hoverColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeColor", false)
      }
    },
    activeTextIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("activeTextIsThemeColor") ? this.options.activeTextIsThemeColor : this.options.hoverTextIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTextIsThemeColor", false)
      }
    },
    activeTextAlign: {
      get() {
        return this.options.activeTextAlign || this.options.textAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTextAlign", false)
      }
    },
    activeFontStyle: {
      get() {
        return this.options.activeFontStyle || this.options.hoverFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontStyle", false)
      }
    },
    activeLineHeight: {
      get() {
        return this.options.hasOwnProperty("activeLineHeight") ? this.options.activeLineHeight : this.options.hoverLineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeLineHeight", false)
      }
    },
    activeLetterSpacing: {
      get() {
        return this.options.hasOwnProperty("activeLetterSpacing")
          ? this.options.activeLetterSpacing
          : this.options.hoverLetterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "hoverLetterSpacing", false)
      }
    },
    activeWritingMode: {
      get() {
        return this.options.hasOwnProperty("activeWritingMode")
          ? this.options.activeWritingMode
          : this.options.hoverWritingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeWritingMode", false)
      }
    },
    activeTextDecoration: {
      get() {
        return this.options.activeTextDecoration || this.options.hoverTextDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTextDecoration", false)
      }
    },
    activeBgColor: {
      get() {
        return this.options.activeBgColor || this.options.hoverBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBgColor", false)
      }
    },
    activeBgColorIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("activeBgColorIsThemeColor") ? this.options.activeBgColorIsThemeColor : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBgColorIsThemeColor", false)
      }
    },
    activeBorderIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("activeBorderIsThemeColor") ? this.options.activeBorderIsThemeColor : this.hoverBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderIsThemeColor", false)
      }
    },
    showActiveBorder: {
      get() {
        let showBorder = false
        if (this.options.showActiveBorder === undefined) {
          if (Array.isArray(this.options.activeBorderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.activeBorderWidth.length; i++) {
              if (this.options.activeBorderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              showBorder = false
            } else {
              showBorder = true
            }
          } else {
            if (this.options.activeBorderWidth) {
              showBorder = true
            } else {
              showBorder = false
            }
          }
        } else {
          showBorder = this.options.showActiveBorder
        }
        return showBorder
      },
      set(newVal) {
        if(newVal && !this.activeBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["activeBorderWidth", "showActiveBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showActiveBorder", false)
        }
      }
    },
    activeBorderWidth: {
      get() {
        return this.options.hasOwnProperty("activeBorderWidth")
          ? this.options.activeBorderWidth
          : this.options.hoverBorderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderWidth", false)
      }
    },
    activeBorderColor: {
      get() {
        return this.options.activeBorderColor || this.options.hoverBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderColor", false)
      }
    },
    activeBorderStyle: {
      get() {
        return this.options.hasOwnProperty("activeBorderStyle")
          ? this.options.activeBorderStyle
          : this.options.hoverBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderStyle", false)
      }
    },
    activeBorderChecked: {
      get() {
        return this.options.activeBorderChecked || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderChecked", false)
      }
    },
    activeUnderlineColor: {
      get() {
        return this.options.activeUnderlineColor || this.options.hoverUnderlineColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeUnderlineColor", false)
      }
    },
    activeUnderlineStyle: {
      get() {
        return this.options.activeUnderlineStyle || this.options.hoverUnderlineStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeUnderlineStyle", false)
      }
    },
    activeUnderlineWidth: {
      get() {
        return this.options.activeUnderlineWidth || this.options.hoverUnderlineWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeUnderlineWidth", false)
      }
    },
    activeActiveArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.activeWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "activeWritingMode", false)
      }
    },
    activeActiveArrangement() {
      return this.options.hoverTextAlign
    },
    activeLineHeightType: {
      get() {
        return this.options.activeLineHeightType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeLineHeightType", false)
      }
    },
    activeLetterSpacingType: {
      get() {
        return this.options.activeLetterSpacingType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeLetterSpacingType", false)
      }
    },
    activeBorderTopLeftRadius: {
      get() {
        return this.options.hasOwnProperty("activeBorderTopLeftRadius") ? this.options.activeBorderTopLeftRadius : this.hoverBorderTopLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderTopLeftRadius", false)
      }
    },
    activeBorderTopRightRadius: {
      get() {
        return this.options.hasOwnProperty("activeBorderTopRightRadius") ? this.options.activeBorderTopRightRadius : this.hoverBorderTopRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderTopRightRadius", false)
      }
    },
    activeBorderBottomRightRadius: {
      get() {
        return this.options.hasOwnProperty("activeBorderBottomRightRadius") ? this.options.activeBorderBottomRightRadius : this.hoverBorderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderBottomRightRadius", false)
      }
    },
    activeBorderBottomLeftRadius: {
      get() {
        return this.options.hasOwnProperty("activeBorderBottomLeftRadius") ? this.options.activeBorderBottomLeftRadius : this.hoverBorderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderBottomLeftRadius", false)
      }
    },
    activeBorderRadius: {
      get() {
        return this.options.hasOwnProperty("activeBorderRadius") ? this.options.activeBorderRadius : this.hoverBorderRadius
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          ["activeBorderTopLeftRadius", "activeBorderTopRightRadius", "activeBorderBottomRightRadius", "activeBorderBottomLeftRadius"],
          false
        )
        this.$changeOptionsEV(newVal, "activeBorderRadius", false)
      }
    },
   activeBorderTypeFlag: {
      get() {
        let defaultType = this.hoverBorderTypeFlag
        if (!this.options.hasOwnProperty("activeBorderTypeFlag")) {
          if (
            ((this.activeBorderTopLeftRadius === this.activeBorderTopRightRadius) === this.activeBorderBottomLeftRadius) ===
            this.activeBorderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.options.activeBorderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderTypeFlag", false)
      }
    },
    /* 悬浮样式end */
    showDivide: {
      get() {
        return this.options.hasOwnProperty("showDivide") ? this.options.showDivide : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showDivide", false)
      }
    },
    divideType: {
      get() {
        return this.options.hasOwnProperty("divideType") ? this.options.divideType : "line"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideType", false)
      }
    },
    divideWidth: {
      get() {
        return this.options.hasOwnProperty("divideWidth") ? this.options.divideWidth : 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideWidth", false)
      }
    },
    divideHeight: {
      get() {
        return this.options.hasOwnProperty("divideHeight") ? this.options.divideHeight : 24
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideHeight", false)
      }
    },
    divideIconSrc: {
      get() {
        return this.options.hasOwnProperty("divideIconSrc") ? this.options.divideIconSrc : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideIconSrc", false)
      }
    },
    divideIconType: {
      get() {
        return this.options.hasOwnProperty("divideIconType") ? this.options.divideIconType : "icon"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideIconType", false)
      }
    },
    divideIconColorIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("divideIconColorIsThemeColor") ? this.options.divideIconColorIsThemeColor : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideIconColorIsThemeColor", false)
      }
    },
    divideIconColor: {
      get() {
        return this.options.hasOwnProperty("divideIconColor") ? this.options.divideIconColor : "rgba(0,0,0,0.2)"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideIconColor", false)
      }
    },
    divideResInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "divideResInfo", "divideResInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideResInfo", false)
      }
    },
    // 悬浮 边距
    hoverPaddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("hoverPaddingTypeFlag")) {
          if (((this.hoverPaddingTop === this.hoverPaddingRight) === this.hoverPaddingLeft) === this.hoverPaddingBottom) {
            defaultType = 2
          }
        }
        return this.options.hoverPaddingTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPaddingTypeFlag", false)
      }
    },
    hoverPadding: {
      get() {
        return this.options.hoverPadding || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPadding", false)
      }
    },
    hoverPaddingTop: {
      get() {
        return this.options.hoverPaddingTop || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPaddingTop", false)
      }
    },
    hoverPaddingRight: {
      get() {
        return this.options.hoverPaddingRight || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPaddingRight", false)
      }
    },
    hoverPaddingLeft: {
      get() {
        return this.options.hoverPaddingLeft || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPaddingLeft", false)
      }
    },
    hoverPaddingBottom: {
      get() {
        return this.options.hoverPaddingBottom || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPaddingBottom", false)
      }
    },
    // 选中 边距
    activePaddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("activePaddingTypeFlag")) {
          if (((this.activePaddingTop === this.activePaddingRight) === this.activePaddingLeft) === this.activePaddingBottom) {
            defaultType = 2
          }
        }
        return this.options.activePaddingTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activePaddingTypeFlag", false)
      }
    },
    activePadding: {
      get() {
        return this.options.activePadding || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activePadding", false)
      }
    },
    activePaddingTop: {
      get() {
        return this.options.activePaddingTop || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activePaddingTop", false)
      }
    },
    activePaddingRight: {
      get() {
        return this.options.activePaddingRight || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activePaddingRight", false)
      }
    },
    activePaddingLeft: {
      get() {
        return this.options.activePaddingLeft || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activePaddingLeft", false)
      }
    },
    activePaddingBottom: {
      get() {
        return this.options.activePaddingBottom || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activePaddingBottom", false)
      }
    },
  },
  methods: {
    switchHandle(type) {
      this.activeType = type
    },
    changeAlignType(value) {
      this.alignType = value
    },
    changeBorderRadiusType(value) {
      this.borderTypeFlag = value
    },
    changeStyle(flag, temp, ishover) {
      switch (flag) {
        case 0:
          let weightPropName = ishover ? "hoverFontWeight" : "fontWeight"
          if (temp) {
            this.fontStyleList[flag].isActive = false
            this[weightPropName] = 400
          } else {
            this.fontStyleList[flag].isActive = true
            this[weightPropName] = 500
          }
          break
        case 1:
          let stylePropName = ishover ? "hoverFontStyle" : "fontStyle"
          if (temp) {
            this.fontStyleList[flag].isActive = false
            this[stylePropName] = "normal"
          } else {
            this.fontStyleList[flag].isActive = true
            this[stylePropName] = "italic"
          }
          break
        case 2:
          let textPropName = ishover ? "hoverTextDecoration" : "textDecoration"
          if (temp) {
            this.fontStyleList[flag].isActive = false
            this[textPropName] = "none"
          } else {
            this.fontStyleList[flag].isActive = true
            this[textPropName] = "underline"
          }
          break
      }
    },
    changeArrangement(val, hoverFlag) {
      let cutTextAlign = hoverFlag ? hoverFlag + "TextAlign" : "textAlign"
      this[cutTextAlign] = val.value
    },
    changeArrangementOrder(flag, hoverFlag) {
      let curActiveArrangementOrder = hoverFlag ? hoverFlag + "ActiveArrangementOrder" : "activeArrangementOrder"
      let curWritingMode = hoverFlag ? hoverFlag + "WritingMode" : "writingMode"
      if (flag) {
        this[curActiveArrangementOrder].isActive = false
        this.$changeOptionsEV("horizontal-tb", curWritingMode, false)
      } else {
        this[curActiveArrangementOrder].isActive = true
        this.$changeOptionsEV("vertical-lr", curWritingMode, false)
      }
    },
    changeClassLength() {
      if (this.singleTabs) return
      const params = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        elementInLayoutId: this.ids.elementInLayoutId,
        directionIndex: this.ids.directionIndex,
        maxLength: this.maxLength
      }
      this.$store.dispatch(this.request_prefix + "/changeLayoutTabsLength", params)
    },
    resetBorder(val) {
      this.borderRadius = val
      this.borderTopLeftRadius = val
      this.borderTopRightRadius = val
      this.borderBottomRightRadius = val
      this.borderBottomLeftRadius = val
    },
    collapseMouseDownOther($event, val) {
      if (val === "8" && this.allTabs.length === 0) {
        this.getAllTabs()
      }
    },
    // 获取当前tab组件的的所有选项卡
    getAllTabs() {
      let syncTabIndexList = [] // 除去当前选中的tab的所有tab的index集合
      const rectAttr = this.getRectAttribute.call(this, this.ids)
      for (let i = 0; i < rectAttr.options.rows.length; i++) {
        if (i !== rectAttr.options.activeIndex) {
          const obj = {
            index: i,
            isChecked: false
          }
          syncTabIndexList.push(obj)
        }
      }
      this.allTabs = syncTabIndexList
    },
    // 同步当前选中tab对应的col
    syncTab() {
      for (let i = 0; i < this.allTabs.length; i++) {
        if (this.allTabs[i].isChecked) {
          const rectAttr = this.getRectAttribute.call(this, this.ids)
          const useActiveIndex = rectAttr.options.categoryMode === CATEGORY_MODE.SAME ? 0 : rectAttr.options.activeIndex
          const result = {
            ...this.ids,
            content: JSON.parse(JSON.stringify([rectAttr.options.rows[useActiveIndex]]))[0],
            index: this.allTabs[i].index
          }
          deepChangeAnimateUid(result.content)
          this.$store.dispatch(this.request_prefix + "/changeTabMapRowContent", result)
        }
      }
    },
    // 选中所有tab
    checkAllTabsHandle($event) {
      this.allTabsIsCheckedAll = false // 去掉部分选中状态
      this.allTabs.map(item => (item.isChecked = $event))
    },
    // 选中当前tab
    changeTabsCheckedHandle(val, index) {
      let checkedTabs = 0
      this.allTabs[index].isChecked = val
      this.allTabs.map(item => {
        if (item.isChecked) {
          checkedTabs++
        }
      })
      if (checkedTabs === 0) {
        this.allTabsIsCheckedAll = false
        this.getAllTabsIsCheckedAll = false
      } else {
        if (checkedTabs !== this.allTabs.length) {
          this.allTabsIsCheckedAll = true
        } else {
          this.allTabsIsCheckedAll = false
          this.getAllTabsIsCheckedAll = true
        }
      }
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    addBoxshadow(prefix) {
      if (!Array.isArray(this[`${prefix}oxShadowH`])) {
        this[`${prefix}oxShadowH`] = [this[`${prefix}oxShadowH`]]
        this[`${prefix}oxShadowV`] = [this[`${prefix}oxShadowV`]]
        this[`${prefix}oxShadowBlur`] = [this[`${prefix}oxShadowBlur`]]
        this[`${prefix}oxShadowSpread`] = [this[`${prefix}oxShadowSpread`]]
        this[`${prefix}oxShadowColor`] = [this[`${prefix}oxShadowColor`]]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this[`${prefix}oxShadowH`]))
      let boxShadowV = JSON.parse(JSON.stringify(this[`${prefix}oxShadowV`]))
      let boxShadowBlur = JSON.parse(JSON.stringify(this[`${prefix}oxShadowBlur`]))
      let boxShadowSpread = JSON.parse(JSON.stringify(this[`${prefix}oxShadowSpread`]))
      let boxShadowColor = JSON.parse(JSON.stringify(this[`${prefix}oxShadowColor`]))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this[`${prefix}oxShadowH`] = boxShadowH
      this[`${prefix}oxShadowV`] = boxShadowV
      this[`${prefix}oxShadowBlur`] = boxShadowBlur
      this[`${prefix}oxShadowSpread`] = boxShadowSpread
      this[`${prefix}oxShadowColor`] = boxShadowColor
    },
    changeSubItem(val, flag) {
      this.statusType = "1"
      this.curSub = val
      if (val === 1) {
        // this.subName = "切换项"
        // this.activeTypeOptions = this.activeTypeOptions1
      }
      this.$emit("update:statusOpened", flag)
      this.$emit("update:styleOpened", !flag)
      this.$emit("onHideHeader", flag)
      if (val === 1) {
        this.$eventBus.$emit('enableOpen', this.ids)
      }
    }
  }
})
</script>

<style lang="scss" scoped>
.w88 {
  width: 88px;
}
.w72 {
  width: 72px;
}
.content-item {
  .font-style input {
    width: 100%;
    height: 28px;
  }
}
.col_li {
  padding-left: 8px;
}
.col_li:hover {
  background: var(--themeColorSelectBg);
}
.syncCol_flex {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.syncCol_btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 80px;
  height: 28px;
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
}
.syncCol_content {
  background: var(--inputArrowBgColor);
  border: 1px solid var(--borderColorTen);
  border-radius: 4px;
  padding: 8px 4px;
}
</style>
